import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, LogIn, AlertCircle } from 'lucide-react';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/health');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a1f13] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <a href="https://healthchoices.health" target="_blank" rel="noopener noreferrer">
            <img src="https://healthchoices.health/wp-content/uploads/2025/10/logo-1-296x86.png" alt="HealthChoices" className="h-14 mx-auto mb-4 brightness-0 invert" />
          </a>
          <h1 className="text-2xl font-bold text-white">Welcome Back</h1>
          <p className="text-gray-400 mt-1">Sign in to your health dashboard</p>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-2xl">
          {error && (
            <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-xl mb-6 text-sm text-red-700" data-testid="login-error">
              <AlertCircle className="w-4 h-4 flex-shrink-0" /> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label className="text-sm font-medium text-gray-700">Email</Label>
              <Input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                placeholder="you@example.com" className="mt-1" data-testid="login-email" />
            </div>
            <div>
              <Label className="text-sm font-medium text-gray-700">Password</Label>
              <Input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                placeholder="Enter your password" className="mt-1" data-testid="login-password" />
            </div>

            <Button type="submit" disabled={loading} className="w-full bg-[#166534] hover:bg-[#14532d] text-white py-5 rounded-xl" data-testid="login-submit">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><LogIn className="w-4 h-4 mr-2" /> Sign In</>}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-gray-500">
            Don't have an account?{' '}
            <Link to="/register" className="text-[#166534] font-medium hover:underline" data-testid="go-to-register">Create one</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
